import request from "./request";

// 获取图形验证码
export const getCaptchaAuth = () => {
  return request({
    url: "/user/getCaptcha",
  });
};

// 登录发送验证码
export const sendCode = (params) => {
  return request({
    url: "/conference/user/sendCode",
    params,
  });
};

// 短息验证码登录
export const loginApi = (data) => {
  return request({
    url: "/conference/user/student/sms/login",
    data,
    method: "post",
    showLoading: true,
  });
};

// h5绑定手机
export const bindPhone = (data) => {
  return request({
    url: "/conference/user/sms/public/login",
    data,
    method: "post",
    showLoading: true,
  });
};

// 生成一次性CODE绑定TOKEN
export const tokenGetCode = (params) => {
  return request({
    url: `/user/generate/code`,
    method: "get",
    params,
    showLoading: true,
  });
};
// 消费CODE换取TOKEN
export const codeExchangeToken = (params) => {
  return request({
    url: `/user/codeExchangeToken`,
    method: "get",
    params,
    showLoading: true,
  });
};

// 退出登录
export const logoutApi = () =>
  request({
    url: "/conference/user/logout?source=PC",
  });

// 获取用户信息
export const getUserInfoApi = () =>
  request({
    url: "/user/getUserInfoById",
  });

// 记录用户行为
export const setUserViewsRecords = (data) => {
  return request({
    url: "/user/addPageBrowserRecord",
    method: "post",
    data,
  });
};

// 用户点赞收藏
export const addUserRecords = (data) => {
  return request({
    url: "/collection/addCollect",
    method: "post",
    data,
  });
};

// 用户取消点赞收藏
export const updateUserRecords = (data) => {
  return request({
    url: "/collection/cancelCollect",
    method: "post",
    data,
  });
};

// 用户获取首页数据
export const getHomeDate = (id) => {
  return request({
    url: `/cancel/user/getHomeDate/${id}`,
    method: "get",
  });
};

// 修改密码

export const updatePasswordEmailApi = (data) =>
  request({
    url: "/user/updatePasswordEmail",
    method: "post",
    data,
  });

// addByEmailApi添加学员 根据邮箱
export const addByEmailApi = (data) =>
  request({
    url: "/user/student/addByEmail",
    method: "post",
    data,
  });

// 根据邮箱登录
export const emallLoginApi = (data) =>
  request({
    url: "/user/email/login",
    method: "post",
    data,
  });

// 核销人员登录
export const expertLogin = (data) => {
  return request({
    url: "/user/expert/login",
    method: "post",
    data,
  });
};

// 通用会务端获取用户数据
export const getUserMeetingDate = (params) => {
  return request({
    url: `/cancel/conference/getUserDate/${params.platformId}/${params.userId}`,
    method: "get",
    WriteToken: true,
  });
};

// 通用大会会务端核销数据
export const currencyCancelDate = (id) => {
  return request({
    url: `/cancel/conference/cancelDate/${id}`,
    method: "post",
    WriteToken: true,
  });
};

export const conferenceEnConfig = (params) => {
  return request({
    url: `/dict/list`,
    method: "get",
    params,
  });
};

// 发送邮件
export const sendEmail = (data) => {
  return request({
    url: "sendEmail/single",
    method: "post",
    data,
  });
};

// 取消提交表单状态
export const cancelSubmitForm = (id) => {
  return request({
    url: `/form/content/updateStatusCancel/${id}`,
    method: "post",
  });
};
